export default __webpack_public_path__ + "static/media/mainRedeemFlowers.5ef296b3.png";